
import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import { getPartnerWiseClientDropdown } from '../../../Redux/client/action';
import { FaSpinner } from 'react-icons/fa'; // Spinner icon

const ClientDropDown = ({ lockboxformik, isSingle = false, width = "250px", name = "clients",isPartner=true,isDisabled=false,isDisableOnchange=false,fontSize = '17px' }) => {
	const [isFocusedClient, setIsFocusedClient] = useState(false);
	const [clients, setClients] = useState([]);
	const [isLoadingClients, setIsLoadingClients] = useState(false); // 🆕

	const DropdownIndicator = ({ state, ...props }) => {
		return (
			<components.DropdownIndicator {...props}>
				{isLoadingClients ? (
					<FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
				) : lockboxformik.values?.[state]?.length > 1 ? (
					<TbGridDots style={{ fontSize: "1.5em" }} />
				) : (
					<HiChevronDown style={{ fontSize: "1.5em" }} />
				)}
			</components.DropdownIndicator>
		);
	};

	useEffect(() => {
		let apiTimeout = null;

		if (isPartner && lockboxformik?.values?.partner?.length === 0) {
			lockboxformik.setFieldValue(name, []);
		}

		setIsLoadingClients(true); // 🆕 Start loading

		apiTimeout = setTimeout(() => {
			getPartnerWiseClientDropdown(lockboxformik?.values?.partner || [])((response) => {
				setIsLoadingClients(false); // 🆕 End loading

				if (response && response.status) {
					const apiResponse = response?.data?.clients || [];
					const selectedClientIds = apiResponse.flatMap(i => i?.clients)?.map(ite => ite.value);
					const filterFacility = lockboxformik?.values?.[name]?.filter(i => selectedClientIds.includes(i));

					if (isPartner && lockboxformik?.values?.partner?.length > 0) {
						lockboxformik.setFieldValue(name, filterFacility || []);
					}

					setClients(
						apiResponse.map((result) => ({
							options: result?.clients,
							label: result?.partner
						}))
					);
				}
			});
		}, 600);

		return () => clearTimeout(apiTimeout);
	}, [lockboxformik?.values?.partner]);

	const handleChange = (e) => {
		lockboxformik.setFieldValue(name, !isSingle ? e.map(i => i.value) : [e?.value]);
	};

	const value = !isSingle
	
		? clients?.flatMap(i => i?.options)?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value))
		
		: clients[0]?.options?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value));

	return (
		<div style={{ width: `${width}` }}>
			<Form.Group>
				<Select
					className="basic-single select-search-facility"
					classNamePrefix="select"
                    isDisabled={isLoadingClients||isDisabled}
					isMulti={!isSingle}
					tabSelectsValue={false}
					closeMenuOnSelect={isSingle}
					value={value}
					name={name}
					components={{
						DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
					}}
					options={clients}
					onFocus={() => setIsFocusedClient(true)}
					onBlur={() => setIsFocusedClient(false)}
					onChange={isDisableOnchange ? undefined : handleChange}
					placeholder="Clients"
					menuPortalTarget={document.body}
					styles={{
						container: (styles) => ({
							...styles,
							borderRadius: "9px"
						}),
						placeholder: (styles) => ({
							...styles,
							fontSize: fontSize
						}),
						control: (styles, state) => ({
							...styles,
							backgroundColor: "hsl(204deg 33.33% 97.06%)",
							borderStyle: "none",
							boxShadow: "none",
							borderRadius: "10px",
							maxHeight: state.isFocused ? "auto" : "30px"
						}),
						indicatorSeparator: (styles) => ({
							...styles,
							width: "0px",
							minHeight: "20px"
						}),
						valueContainer: (styles, state) => ({
							...styles,
							maxHeight: isFocusedClient ? "auto" : "30px"
						}),
						menuPortal: (styles) => ({
							...styles,
							zIndex: 9999
						})
					}}
				/>
				{lockboxformik.errors?.[name] &&
					<span className='text-danger'>{lockboxformik.errors?.[name]}</span>
				}
			</Form.Group>
		</div>
	);
};

export default React.memo(ClientDropDown);
